export default __webpack_public_path__ + "static/media/32.f8f1e5fe.jpg";